// extracted by mini-css-extract-plugin
module.exports = {"gameItemWrapper":"_2CrJgtB","gameGridImage":"_gWmxSpT","gameItemText":"_2g8TJQS"};